var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoOrg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 149,
    viewBox: "0 0 500 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.514 135.914C62.5171 115.361 83.1039 85.6248 83.1039 85.6248C83.1039 85.6248 120.715 39.5721 136.969 18.5141C120.545 18.5141 101.151 18.193 91.7472 30.4014C82.8797 41.9136 77.4384 48.9778 68.5709 60.4901C68.5709 60.4901 51.4424 80.8009 54.8438 97.358C58.5976 109.359 59.7673 122.318 57.514 135.914Z",
    fill: "#32B2DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.1071 85.6265C83.1071 85.6265 62.5201 115.363 57.5171 135.915C57.2781 137.358 57.0005 138.808 56.6834 140.264C56.055 143.15 55.2716 146.062 54.3251 148.998C63.8834 148.998 73.4417 148.998 83 148.998C89.3148 139.288 92.7233 108.133 83.1071 85.6265Z",
    fill: "#32B2DD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.8477 97.3589C51.4463 80.8019 68.5748 60.491 68.5748 60.491C62.136 52.1318 59.5738 48.4729 52.9756 40.2394C38.2974 21.9235 29.7843 17.9944 0 18.5149C12.6718 34.8101 37.7822 62.8532 47.4831 80.2934C50.5026 85.7217 52.9912 91.4233 54.8477 97.3589Z",
    fill: "url(#paint0_linear_1260_3152)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.8478 97.3571C53.197 89.3209 56.3824 80.4006 60.0985 73.3473C36.2952 20.565 0 18.5133 0 18.5133C12.6718 34.8085 37.7822 62.8516 47.4832 80.2917C50.5026 85.7201 52.9912 91.4216 54.8478 97.3571Z",
    fill: "#32B2DD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M280.729 121.334C295.668 121.334 308.117 109.37 308.117 94.1664C308.117 78.9625 295.668 66.7496 280.729 66.7496C265.79 66.7496 253.59 78.9625 253.59 94.1664C253.59 109.121 265.79 121.334 280.729 121.334ZM225.954 94.1664C225.954 63.7587 250.354 39.3328 280.729 39.3328C311.105 39.3328 335.505 63.7587 335.505 94.1664C335.505 124.574 311.105 149 280.729 149C250.354 149 225.954 124.574 225.954 94.1664Z",
    fill: "#32B2DD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M162.075 121.334C177.014 121.334 189.463 109.37 189.463 94.1664C189.463 78.9625 177.014 66.7496 162.075 66.7496C147.136 66.7496 134.936 78.9625 134.936 94.1664C134.936 109.121 147.136 121.334 162.075 121.334ZM107.3 94.1664C107.3 63.7587 131.7 39.3328 162.075 39.3328C192.451 39.3328 216.85 63.7587 216.85 94.1664C216.85 124.574 192.451 149 162.075 149C131.7 149 107.3 124.574 107.3 94.1664Z",
    fill: "#32B2DD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M258.566 91.8716C258.566 95.2476 259.285 98.586 260.677 101.671C262.068 104.756 264.102 107.518 266.645 109.779C269.188 112.041 272.185 113.75 275.441 114.798C278.697 115.845 282.14 116.207 285.547 115.861L284.604 106.863C282.475 107.08 280.323 106.853 278.289 106.199C276.254 105.544 274.381 104.476 272.792 103.062C271.202 101.649 269.932 99.9231 269.062 97.9953C268.192 96.0676 267.743 93.9813 267.743 91.8716H258.566Z",
    fill: "#F9A533"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M334.742 61.7197V17.5716L286.541 31.1765C296.125 31.8292 305.694 34.8097 314.41 40.3325C323.125 45.8566 329.962 53.2703 334.742 61.7197Z",
    fill: "#F9A533"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M500 148.999H472.329V39.1957H500V148.999Z",
    fill: "#32B2DD"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M486.04 0C493.768 0.000221111 500 6.23938 500 13.7258C500 21.4617 493.768 27.7004 486.04 27.7006C478.562 27.7006 472.329 21.4618 472.329 13.7258C472.329 6.23925 478.561 0 486.04 0Z",
    fill: "#32B2DD"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M377.503 35.4997L377.503 87.6077C377.503 87.6077 419.083 42.0736 422.07 39.2546C431.605 32.8157 459.578 39.2343 459.666 39.2546L418.087 84.1179L418.081 84.1227L418.087 84.1223C441.989 90.1041 459.667 111.788 459.667 137.46V148.926H432.03V137.46C432.03 122.506 419.581 110.044 404.642 110.044L394.179 110.044C393.892 110.281 382.736 119.551 379.406 129.281C378.154 132.937 377.671 137.659 377.503 141.556L377.503 148.926H349.867V16.7983L377.503 35.4997Z",
    fill: "#32B2DD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1260_3152",
    x1: 391.655,
    y1: 159.239,
    x2: 371.967,
    y2: -87.7732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0795C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92E4FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOrg);
export default __webpack_public_path__ + "static/media/Logo-Org.3381c9cebf44904f163592a31f96a49f.svg";
export { ForwardRef as ReactComponent };